import { load } from 'recaptcha-v3'

export default ($form, data) => {
    const init = () => {
        if ($form && $form.length) {
            $form[0].checkValidity();
            $('.success-message', $form).removeClass('d-flex').addClass('d-none').text('');
            $('.failure-message', $form).removeClass('d-flex').addClass('d-none').text('');
            $('.form-group > label', $form).removeClass('text-light');
        }
    }

    const validate = () => {
        $($form).on('input', 'select:visible,input[type=hidden],:input:visible,textarea:visible', function() {
            const $formGroup = $(this).closest('.form-group');
            $formGroup.find('label').removeClass('text-blue');
            $formGroup.find('label').addClass('text-light');
            $formGroup.find('.invalid-feedback').html('');

            $(this).removeClass('is-valid').removeClass('is-invalid');

            if (this.checkValidity()) {
                $(this).removeClass('is-invalid');
                $(this).next('select:not(:visible),:input:not(:visible)').removeClass('is-invalid');
            }
            else {
                $(this).addClass('is-invalid');
            }

            /** Remove error message if form is valid
            var isValid = true;
            $('select:visible,input[type=hidden],:input:visible,textarea:visible', $form).each(function() {
                if (!this.checkValidity()) {
                    isValid = false;
                }
            });

            if (isValid) {
                $('.failure-message', $form).removeClass('d-flex').addClass('d-none');
            }
            **/
        })
    }

    const scrollTo = (selector, duration, offset=0) => {
        const $el = $(selector);

        if ($el && $el.length) {
            $('html, body').animate({
                scrollTop: parseInt($el.offset().top - offset),
            }, duration || 1000);
        }
    }

    const useCaptcha = () => {
        reloadCaptcha();

        if (!window.__initCaptchaReload) {
            console.log('init captcha reload');
            window.__initCaptchaReload = true;
            
            setInterval(function () {
                reloadCaptcha();
            }, 60 * 1000);
        }
    }

    const reloadCaptcha = () => {
        load(window.meta_object.captcha_site_key, {
            autoHideBadge: false,
        }).then((recaptcha) => {
            recaptcha.execute('submit').then((token) => {
                window.meta_object.captcha_token = token;
            });
        });
    }

    const run = () => {
        $('.form-group > label', $form).addClass('text-blue');
        $('.form-group .form-control, .form-group > .input-group:has(.form-control), .custom-control > .custom-control-input, .form-group > .custom-file-input', $form).removeClass('is-invalid').addClass('is-valid');

        if (!data.success && data.fields) {
            for (var field in data.fields) {
                $('[name="' + field + '"]', $form).closest('div:has(label)').find('label').removeClass('text-blue').addClass('text-light');
                $('[name="' + field + '"],.form-control[for="' + field + '"],.input-group:has([name="' + field + '"])', $form).removeClass('is-valid').addClass('is-invalid');
                $('[name="' + field + '"] ~ .invalid-feedback,.input-group:has([name="' + field + '"]) ~ .invalid-feedback', $form).text(data.fields[field][0]);
            }
        }
        else if (data.success) {
            //$(':submit', $form).removeClass('d-block').removeClass('d-flex').addClass('d-none');
        }

        if (data.message) {
            if (data.success) {
                $('.success-message', $form).removeClass('d-none').addClass('d-flex').text(data.message)
                
                setTimeout(function() {
                    $('.success-message', $form).fadeOut(1000, 'linear', function() {
                        $('.success-message', $form).removeClass('d-flex').addClass('d-none').css('display', '');
                    });
                }, 2000);

                $('.failure-message', $form).removeClass('d-flex').addClass('d-none').text('');
            }
            else {
                $('.success-message', $form).removeClass('d-flex').addClass('d-none').text('');
                $('.failure-message', $form).removeClass('d-none').addClass('d-flex').text(data.message);
            }
        }

        var $msg = $('.is-invalid', $form);
        if (!$msg || !$msg.length) {
            $msg = $('.failure-message:not(:hidden)', $form);
        }

        if ($msg && $msg.length) {
            if ($('header').css('position') != 'sticky') {
                scrollTo($msg, 1000, 70);
            }
            else {
                scrollTo($msg, 1000, 140);
            }
        }
    }

    return {init, validate, run, scrollTo, useCaptcha, reloadCaptcha};
}


// WEBPACK FOOTER //
// ./scripts/util/formMessages.js